/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Thickness {
    THIN = 'Thin',
    MEDIUM = 'Medium',
    THICK = 'Thick',
}
